import { props, state, resolveObject } from 'cerebral/tags'
import { set, when, unset } from 'cerebral/operators'
import { httpUploadFile } from '@cerebral/http/operators'
import getURL from 'utils/getURL'
import getCurrentMediaId from '../actions/getCurrentMediaId'

export default [
  set(state`media.details.previewUploaded`, false),
  set(state`media.overridePreview.file`, props`file`),
  set(state`media.overridePreview.progress`, 0),
  getCurrentMediaId,
  function({ props }) {
    let localToken = localStorage.getItem('bmsToken')
    return {
      headers: {
        mediaid: props.id,
        token: localToken
      }
    }
  },
  httpUploadFile(
    getURL('/upload'),
    props`file`,
    resolveObject({
      name: 'file',
      headers: props`headers`,
      onProgress: 'media.onUploadPreviewProgress'
    })
  ),
  {
    success: [
      when(props`response.result`),
      {
        true: [],
        false: []
      },
      unset(state`media.overridePreview.progress`)
    ],
    error: [],
    abort: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/onOverridePreview.js